{
  "title": "Hypnotic Pattern",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level illusion",
  "level": 3,
  "castingTime": "1 action",
  "range": "120 feet",
  "components": "S, M (a glowing stick of incense or a crystal vial filled with phosphorescent material)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You create a twisting pattern of colors that weaves through the air inside a 30-foot cube within range. The pattern appears for a moment and vanishes. Each creature in the area who sees the pattern must make a Wisdom saving throw. On a failed save, the creature becomes charmed for the duration. While charmed by this spell, the creature is incapacitated and has a speed of 0.",
    "The spell ends for an affected creature if it takes any damage or if someone else uses an action to shake the creature out of its stupor."
  ],
  "spellLists": ["bard", "arcane-trickster", "sorcerer", "warlock", "wizard"]
}
